import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

class SearchRecommendApi {
	static getBaseURL() {
		return (localStorage.apiDomain || config.api) + '/service/search-recommend';
	}

	static getInstance() {
		const instance = axios.create({
			baseURL: this.getBaseURL(),
			headers: {
				'Content-Type': 'application/json'
			}
		});

		instance.interceptors.response.use(
			response => response,
			error => {
				if (!error.response || error.response.status === 401) {
					const event = document.createEvent("Event");
					event.initEvent("SessionExpired", true, true);
					document.dispatchEvent(event);
				}
				return Promise.reject(error);
			}
		);

		return instance;
	}
	static get(path) {
		const searchRecommendInstance = this.getInstance();
		searchRecommendInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return searchRecommendInstance.get(path)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static post(path, payload) {
		const searchRecommendInstance = this.getInstance();
		searchRecommendInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return searchRecommendInstance.post(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static patch(path, payload) {
		const searchRecommendInstance = this.getInstance();
		searchRecommendInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return searchRecommendInstance.patch(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static delete(path, payload) {
		const searchRecommendInstance = this.getInstance();
		searchRecommendInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return searchRecommendInstance.delete(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
}

export default SearchRecommendApi;
